import { focusVariants } from './nav-link/NavLink'
import { cn } from '@/ui/utils/style'
import { links } from '@/ui/constants/links'
import { NavBarDialogue } from '@/features/newsletter/NavBarDialogue'
import { paths } from '@/config/paths'
import Link from 'next/link'

import XLogo from '@/ui/assets/components/social-logos/x-logo.inline.svg'
import TelegramLogo from '@/ui/assets/components/social-logos/telegram-logo.inline.svg'
import DiscordLogo from '@/ui/assets/components/social-logos/discord-logo.inline.svg'
import GithubLogo from '@/ui/assets/components/social-logos/github-logo.inline.svg'

const socialLinks = [
  {
    href: links.social.x,
    icon: XLogo,
  },
  {
    href: links.social.telegram,
    icon: TelegramLogo,
  },

  {
    href: links.social.github,
    icon: GithubLogo,
  },
  {
    href: links.social.discord,
    icon: DiscordLogo,
  },
]

const infoLinks = [
  {
    href: links.docs.home,
    label: 'Docs',
  },
  {
    href: links.docs.security,
    label: 'Audits',
  },
  {
    to: paths.termsOfService,
    label: 'Terms',
  },
]

export function FooterLinks({ mobileMenuCollapsed }: { mobileMenuCollapsed: boolean }) {
  return (
    <div className={cn('flex flex-col items-center gap-4 pb-4 xl:pt-2', mobileMenuCollapsed && 'hidden xl:flex')}>
      <div className="flex items-center justify-center gap-5 xl:justify-start xl:gap-7">
        {socialLinks.map((link) => (
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            key={link.href}
            className={cn(focusVariants(), 'p-3 opacity-30 transition-opacity xl:p-0 hover:opacity-100')}
          >
            <link.icon className="text-foreground" />
          </a>
        ))}
      </div>

      <NavBarDialogue />

      <div className="flex justify-center gap-4 xl:justify-start xl:gap-2">
        {infoLinks.map((link, i) =>
          link.href ? (
            <a
              href={link.href}
              key={link.label}
              target="_blank"
              rel="noopener"
              className={cn(
                focusVariants(),
                'rounded-none text-dim-foreground text-sm transition-colors hover:text-foreground',
                i !== 0 && 'border-border border-l pl-4 xl:pl-2',
              )}
            >
              {link.label}
            </a>
          ) : (
            <Link
              href={link.to}
              key={link.label}
              className={cn(
                focusVariants(),
                'rounded-none text-dim-foreground text-sm transition-colors hover:text-foreground',
                i !== 0 && 'border-border border-l pl-4 xl:pl-2',
              )}
            >
              {link.label}
            </Link>
          ),
        )}
      </div>
    </div>
  )
}
